var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _c("div", { staticClass: "col-12" }, [
      _c(
        "table",
        { staticClass: "table table-sm table-borderless table-striped" },
        [
          _c("tbody", [
            _c("tr", [
              _c("td", [_vm._v("Invoice No")]),
              _vm._v(" "),
              _c("td", [_vm._v(_vm._s(_vm.docket.docNo))]),
              _vm._v(" "),
              _c("td", [_vm._v("Invoice Date")]),
              _vm._v(" "),
              _c("td", [_vm._v(_vm._s(_vm._f("date")(_vm.docket.docDt)))])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("td", [_vm._v("Customer")]),
              _vm._v(" "),
              _c("td", [_vm._v(_vm._s(_vm.docket.customerName))]),
              _vm._v(" "),
              _c("td", [_vm._v("Transporter")]),
              _vm._v(" "),
              _c("td", [
                _vm.docket.transporter
                  ? _c("span", [_vm._v(_vm._s(_vm.docket.transporter.name))])
                  : _vm._e()
              ])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("td", [_vm._v("LR No")]),
              _vm._v(" "),
              _c("td", [_vm._v(_vm._s(_vm.docket.lrNo))]),
              _vm._v(" "),
              _c("td", [_vm._v("LR Dt")]),
              _vm._v(" "),
              _c("td", [_vm._v(_vm._s(_vm._f("date")(_vm.docket.lrDt)))])
            ]),
            _vm._v(" "),
            _c("tr", [
              _vm.docket.returnLrNo
                ? _c("td", [_vm._v("Return LR No")])
                : _vm._e(),
              _vm._v(" "),
              _vm.docket.returnLrNo
                ? _c("td", [_vm._v(_vm._s(_vm.docket.returnLrNo))])
                : _vm._e(),
              _vm._v(" "),
              _c("td", [_vm._v("POD Status")]),
              _vm._v(" "),
              _c(
                "td",
                [_c("p-o-d-status", { attrs: { docket: _vm.docket } })],
                1
              )
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("td", { attrs: { colspan: "1" } }, [
                _vm._v("Delivery Status")
              ]),
              _vm._v(" "),
              _c(
                "td",
                { attrs: { colspan: "3" } },
                [_c("delivery-status", { attrs: { docket: _vm.docket } })],
                1
              )
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _vm.comments && _vm.comments.length > 0
        ? _c("div", { staticClass: "row mb-3" }, [
            _vm._m(0),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-12" },
              [
                _c(
                  "b-list-group",
                  _vm._l(_vm.comments, function(c) {
                    return _c("b-list-group-item", { key: c.id }, [
                      _c(
                        "div",
                        { staticClass: "d-flex w-100 justify-content-between" },
                        [
                          _c("h5", { staticClass: "mb-1" }, [
                            _vm._v(_vm._s(c.commentBy.userName))
                          ]),
                          _vm._v(" "),
                          _c("small", [
                            _vm._v(_vm._s(_vm._f("datetime")(c.commentAt)))
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c("p", { staticClass: "mb-1" }, [
                        _vm._v(_vm._s(c.comment))
                      ])
                    ])
                  }),
                  1
                )
              ],
              1
            )
          ])
        : _vm._e()
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12" }, [
      _c("h4", [_vm._v("Comments")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-446c6836", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-446c6836","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/BasicDocket.vue
// module id = null
// module chunks = 